import { ZfStack, ZfTextButton } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAdvisoryNeedsForTalkingPoint, useClient, useTopics } from '../../../app/api';
import type { TalkingPointDto, TopicDto } from '../../../app/api/generated/client';
import { NeedEventModal } from '../../../app/components/topic/modals/NeedEventModal';
import { useYwuApp } from '../../../app/contexts/ywu-app-context';
import { useWealthPlanningNavigate } from '../../../app/hooks/useWealthPlanningNavigate';
import { buildAdvisoryNeedTask } from '../../../app/utils/eventUtils';
import { wnSendNavigate } from '../../../app/utils/wn-event-utils';
import { LIQUIDITY_PLACEHOLDER_TALKING_POINT_ID, LIQUIDITY_WEALTH_TOPIC_KEY } from '../../config/constants';

export const LiquidityCalculatorFooter: FunctionComponent = () => {
    const { t, i18n } = useTranslation();
    const { isWealthNavigatorMFE } = useYwuApp();
    const { clientUuid } = useWealthPlanningNavigate();
    const { data: topics } = useTopics();
    const { data: client } = useClient();
    const { data: liquidityAdvisoryNeeds } = useAdvisoryNeedsForTalkingPoint(LIQUIDITY_PLACEHOLDER_TALKING_POINT_ID);

    const [isAddToRoadmapOpen, setIsAddToRoadmapOpen] = useState(false);

    const wealthTopic = topics?.find((topic) => topic.key === LIQUIDITY_WEALTH_TOPIC_KEY);
    const liquidityAdvisoryNeed = liquidityAdvisoryNeeds?.[0];
    const placeholderTalkingPoint = { id: LIQUIDITY_PLACEHOLDER_TALKING_POINT_ID } as TalkingPointDto;

    const openModularOfferingProposal = () => {
        if (!clientUuid) return;
        wnSendNavigate(`client-data/${clientUuid}/INTL/modular-offering/offering`);
    };

    return (
        <ZfStack direction="row" alignment="center" justify="flex-end" spacing="large" className="liquidity-planner__footer">
            {isWealthNavigatorMFE && (
                <ZfTextButton size="medium" hierarchy="secondary" disabled={!clientUuid} onClick={openModularOfferingProposal}>
                    {t('liquidityCalculatorModularOfferingProposal')}
                </ZfTextButton>
            )}
            <ZfTextButton size="medium" kind="standard" disabled={!wealthTopic || !liquidityAdvisoryNeed} onClick={() => setIsAddToRoadmapOpen(true)}>
                {t('liquidityCalculatorAddToRoadmap')}
            </ZfTextButton>
            {isAddToRoadmapOpen && wealthTopic && liquidityAdvisoryNeed && (
                <NeedEventModal
                    isOpen={isAddToRoadmapOpen}
                    onClose={() => setIsAddToRoadmapOpen(false)}
                    event={buildAdvisoryNeedTask(
                        i18n.language,
                        { ...wealthTopic, talkingPoints: [] } as TopicDto,
                        placeholderTalkingPoint,
                        liquidityAdvisoryNeed,
                        client,
                    )}
                />
            )}
        </ZfStack>
    );
};
